import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper, Btn } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";
import { capitalizeFirstLetter, formatAmount, getStatusConfig, handleCopy, truncateText } from "../../helpers";
import Tooltip from "../Tooltip";
import { MdDelete } from "react-icons/md";
import { IoCopySharp } from "react-icons/io5";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { IoMdEye, IoMdMore, IoMdTrash } from "react-icons/io";

const Table = ({
    apiData,
    setSelectedData,
    setViewDetails,
    setIsDeleteEntity,
    startDate,
    endDate
}) => {
    const storageKey = `beneficiary_active_page`;
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const [previousId, setPreviousId] = useState(null);

    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    // Load saved page index
    const storageValue = sessionStorage.getItem(storageKey);
    const savedPage = storageValue !== null ? Number(storageValue) : 0;
    const [currentPage, setCurrentPage] = useState(savedPage);

    const view = (item) => {
        setViewDetails(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    const ActionBtnsOld = (item) => (
        <div className="flex items-center gap-2">
            <Tooltip label="View details">
                <button
                    onClick={() => view(item)}
                    //className="text-gray-400 hover:text-blue-600 transition"
                    className="p-2 rounded-full hover:bg-gray-100 transition cursor-pointer"
                >
                    <IoMdEye className="text-gray-400" size={16} />
                </button>
            </Tooltip>
            <Tooltip label="Delete beneficiary">
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        setSelectedData(item);
                        setIsDeleteEntity(true);
                        //deleteLocation(item);
                    }}
                    // className="text-gray-400 hover:text-rose-600 transition"
                    className="p-2 rounded-full hover:bg-gray-100 transition cursor-pointer"
                >
                    <IoMdTrash className="text-gray-400" size={18} />
                </button>
            </Tooltip>
        </div>
    );

    const ActionBtns = (item) => {

        const openMenu = (id) => {
            setPreviousId(openActionMenu);

            setOpenActionMenu((prevId) => {
                return prevId === id ? null : id;
            });
        };

        return (
            <ActionBtnWrapper>
                {openActionMenu === item.id && (
                    <MenuOptions id="menuOptions">

                        {/* View Details */}
                        <MenuItem
                            onClick={() => {
                                view(item);
                            }}
                        >
                            <IoMdEye className="text-gray-700" />
                            View Details
                        </MenuItem>

                        {/* Download Receipt */}
                        <MenuItem
                            onClick={(e) => {
                                e.stopPropagation();
                                setSelectedData(item);
                                setIsDeleteEntity(true);
                                //deleteLocation(item);
                            }}
                        >

                            <IoMdTrash className="text-gray-700" />
                            Delete
                        </MenuItem>

                    </MenuOptions>
                )}

                <Btn
                    title="Actions"
                    type="button"
                    onClick={() => openMenu(item.id)}
                >
                    <IoMdMore
                        className="text-gray-600"
                        size={24}
                    />
                </Btn>
            </ActionBtnWrapper>
        );
    };

    useEffect(() => {
        setCurrentPage(savedPage);
    }, [savedPage]);

    const getStatusBadge = (item) => {
        const status = item?.status;
        const { label, color } = getStatusConfig(status);

        return (
            <span className={`inline-flex items-center py-1 text-sm font-semibold ${color}`}>
                <span className={`h-1.5 w-1.5 rounded-full`} />
                {label}
            </span>
        );
    };

    // Beneficiary Type
    // Tenant
    // Owner
    // Vendor
    // Staff

    useEffect(() => {
        if (apiData && apiData.length > 0) {
            const tempData = apiData.map((item) => ({
                name: getName(item),
                // mobile: getMobile(item),
                accountNumber: getAccountNumber(item),
                id: getBeneficiaryId(item),
                lastPaidDate: getDate(item),
                totalTransactions: getTransfers(item),
                status: getStatusBadge(item),
                createdAt: moment(item.createdAt).format("DD, MMM YY"),
                action: ActionBtns(item),
                //amount: <Amount onClick={() => goToTransfer(item)}>{`₹${item?.totalAmountPaid || 0}`}</Amount>,
                type: getBeneficiaryType(item),
                rawData: item
            }));
            setData(tempData);
        } else if (apiData && apiData.length === 0) {
            setData([]);
        }
    }, [apiData, openActionMenu]);

    const getDate = (item) => {
        const date = moment(item?.lastPaidDate);
        if (!item?.lastPaidDate || !date.isValid() || item?.lastPaidDate === null) {
            return <span>--</span>;
        }
        return (
            <div className="flex items-center"
            >

                <div className="flex flex-col px-1 py-2 rounded-2xl duration-200">
                    {/* Date */}
                    <span className="text-sm text-gray-600 tracking-tight">
                        {date.format("DD MMM YYYY")}
                    </span>

                    {/* Time */}
                    <div className="flex items-center gap-1 mt-0.5">
                        <span className="text-xs uppercase tracking-widest text-gray-400">
                            {date.format("hh:mm A")}
                        </span>
                    </div>
                </div>

            </div>
        );
    };

    const getTransfers = (item) => {
        const isClickable = Number(item?.totalAmountPaid) > 0;
        return (
            <div
                // className="flex flex-col cursor-pointer"
                className={`flex flex-col ${isClickable ? "cursor-pointer" : "cursor-not-allowed opacity-60"
                    }`}
                onClick={() => {
                    if (!isClickable) return;

                    navigate(`/payout/history/${item.id}`, {
                        state: {
                            routeStartDate: startDate,
                            routeEndDate: endDate,
                        },
                    });
                }}
            // onClick={() => navigate(`/payout/transfers/${item.id}`,
            //     {
            //         state: {
            //             routeStartDate: startDate,
            //             routeEndDate: endDate,
            //         },
            //     })}
            >
                <span className="text-sm font-semibold text-gray-800">
                    ₹{formatAmount(item?.totalAmountPaid || 0)} paid
                </span>

                <span className="text-xs text-gray-400">
                    {item?.totalTransactions || 0} Transfers
                </span>
            </div>
        );
    };

    const getBeneficiaryType = (item) => {

        const typeConfig = {
            2: {
                label: "Tenant",
                bg: "bg-blue-50",
                text: "text-blue-700",
                dot: "bg-blue-500",
            },
            5: {
                label: "Landlord",
                bg: "bg-emerald-50",
                text: "text-emerald-700",
                dot: "bg-emerald-500",
            },
            4: {
                label: "Vendor",
                bg: "bg-amber-50",
                text: "text-amber-700",
                dot: "bg-amber-500",
            },
            3: {
                label: "Staff",
                bg: "bg-violet-50",
                text: "text-violet-700",
                dot: "bg-violet-500",
            },
        };

        const config = typeConfig[item?.userType] || {
            label: "Vendor",
            bg: "bg-amber-50",
            text: "text-amber-700",
            dot: "bg-amber-500",
        };

        return (
            <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full ${config.bg}`}>
                <span className={`w-2 h-2 rounded-full ${config.dot}`} />

                <span className={`text-xs font-semibold tracking-wide ${config.text}`}>
                    {config.label}
                </span>
            </div>
        );
    };

    const getName = (item) => (
        <div
            className="flex items-start gap-3 cursor-pointer"
        >
            {/* Avatar */}
            {/* <div className="relative shrink-0">
                <img
                    src={Images.Avatar}
                    alt={item.name}
                    className="w-9 h-9 rounded-full object-cover"
                />
            </div> */}

            {/* Name + Mobile */}
            <div className="flex flex-col min-w-0">
                <span className="font-medium text-gray-600 truncate">
                    {capitalizeFirstLetter(truncateText(item?.name || "Unknown", 20))}
                </span>
                <div className="flex items-center gap-1 text-xs text-gray-400">
                    <span>{'#' + item.mobile}</span>

                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            handleCopy(item.mobile);
                        }}
                        className="hover:text-gray-600 transition"
                        title="Copy number"
                    >
                        <IoCopySharp size={12} />
                    </button>

                </div>

            </div>
        </div>
    );


    const getAccountNumber = (item) => (
        <div className="flex flex-col">
            <span className="text-sm text-gray-600">
                {item?.accountNumber ? `${item.accountNumber}` : "NA"}
            </span>
            <span className="text-xs text-gray-400">
                #{item?.ifsc ? `${item.ifsc}` : "NA"}
            </span>
        </div>
    );

    const getBeneficiaryId = (item) => (
        <div className="flex flex-col">
            <span className="text-sm text-gray-600 uppercase">
                {item?.cfBeneficiaryId || "NA"}
            </span>
        </div>
    );

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {
            return [
                {
                    Header: "Name",
                    accessor: "name",
                },
                // {
                //     Header: "ID",
                //     accessor: "id",
                // },
                {
                    Header: "Transfers",
                    accessor: "totalTransactions",
                },
                // {
                //     Header: "Mobile",
                //     accessor: "mobile",
                // },
            ];
        }

        return [
            {
                Header: "Name",
                accessor: "name",
            },
            // {
            //     Header: "Type",
            //     accessor: "type",
            // },
            {
                Header: "Transfers",
                accessor: "totalTransactions",
            },
            {
                Header: "Last Paid",
                accessor: "lastPaidDate",
            },
            {
                Header: "Added On",
                accessor: "createdAt",
            },
            {
                Header: "Status",
                accessor: "status",
            },
            // {
            //     Header: "Created At",
            //     accessor: "createdAt",
            // },
            {
                Header: "",
                accessor: "action",
            },
        ];
    }, [isMobileView]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        if (pageIndex !== undefined) {
            sessionStorage.setItem(storageKey, pageIndex);
        }
    }, [pageIndex, storageKey]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup, idx) => (
                        <Tr {...headerGroup.getHeaderGroupProps()} key={idx}>
                            {headerGroup.headers.map((column, colIdx) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())} key={colIdx}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr
                                    {...row.getRowProps({ style: { height: "80px" } })}
                                    hasdata={(apiData?.length > 0).toString()}
                                >
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                                style={{ maxWidth: "320px" }}
                                                key={cellIndex}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr key={`expanded-${rowIndex}`}>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li className="flex justify-between">
                                                    <strong>Account Number:</strong>
                                                    <span className="font-mono">{data[rowIndex]?.rawData?.accountNum || "NA"}</span>
                                                </li>
                                                <li className="flex justify-between">
                                                    <strong>Amount:</strong>
                                                    <span className="font-mono">{data[rowIndex]?.rawData?.amount || "NA"}</span>
                                                </li>
                                                <li className="flex justify-between">
                                                    <strong>Paid:</strong>
                                                    <span className="font-mono">{data[rowIndex]?.rawData?.amount || "NA"}</span>
                                                </li>
                                                <li className="flex justify-between">
                                                    <strong>IFSC Code:</strong>
                                                    <span className="font-mono uppercase">{data[rowIndex]?.rawData?.ifsc || "NA"}</span>
                                                </li>
                                                <li className="flex justify-between">
                                                    <strong>ID:</strong>
                                                    <span className="font-mono">{data[rowIndex]?.rawData?.id || "NA"}</span>
                                                </li>
                                                <li className="flex justify-between">
                                                    <strong>Status:</strong>
                                                    <span className="font-mono uppercase">{data[rowIndex]?.rawData?.status || "NA"}</span>
                                                </li>
                                                <li className="flex justify-between">
                                                    <strong>Action:</strong>
                                                    <span className="font-mono uppercase">{data[rowIndex]?.rawData?.action || "NA"}</span>
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};


const CustomTable = tw.table` w-full text-gray-600 `;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Amount = tw.p`
  text-gray-800 
  text-sm 
  font-semibold 
  bg-neutral-100 
  px-3 
  py-1 
  rounded-full 
  inline-flex 
  min-w-[80px]
  justify-center
  cursor-pointer
`;

const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;

const MenuOptions = tw.div`
  absolute bottom-10 right-0 
  py-2 w-44 
  bg-white 
  z-50 
  rounded-lg 
  shadow-xl 
  border border-gray-200
`;

const MenuItem = tw.div`
  flex items-center gap-2 
  px-4 py-2 
  text-sm 
  cursor-pointer 
  hover:bg-gray-50
`;
export default Table;